<template>
  <iGetStarted />
</template>

<script setup lang="ts">
import iGetStarted from "@/views/preview/GetStarted.vue"
</script>
